import { GetStaticProps } from 'next';
import getConfig from 'next/config';
import { ClearInNavbar } from '../../../components/Navbar/ClearNavbar';
import WebinarsDataService from '../../../components/Webinars/Services/webinars.service';
import { isItrProduct } from '../../../components/Webinars/Utils';
import { IHOMPAGE_DATA } from '../../../components/Webinars/Utils/types';
import { WebinarHomepage } from '../../../components/Webinars/WebinarHomePage';
import { b2cData } from '../../../components/cms/layout/components/header';
import { Meta } from '../../../layout/Meta';
import { staticPropsWrapper } from '../../../utils/static-pages/utils';
const { publicRuntimeConfig } = getConfig();

const Webinars = ({ data }: { data: IHOMPAGE_DATA }): JSX.Element => {
  return (
    <div>
      {isItrProduct({ id: data.productId }) ? (
        <ClearInNavbar data={b2cData} />
      ) : (
        <ClearInNavbar />
      )}

      <Meta
        title="Free Webinars on Income Tax, GST, E-Invoicing, TDS, Mutual Funds & Accounting"
        description="Register now for Free Webinars on topics of interest for small businesses, individuals and tax professionals. GST Webinars | Income Tax Webinars | Mutual Fund Investments Webinars"
        canonical={`${publicRuntimeConfig.CLEARTAX_DOMAIN}/webinars`}
        key="robots"
      />
      <WebinarHomepage data={data} />
    </div>
  );
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  async () => {
    const data = {} as IHOMPAGE_DATA;

    try {
      const res = await WebinarsDataService.getAllProductsList();
      data.product = await res.data;
    } catch (err: unknown) {
      console.log(
        'Error fetching products list cleartax.in/webinars ',
        (err as Error)?.message
      );
      return { props: { data: {} as IHOMPAGE_DATA } };
    }
    data.productId = '';
    data.searchString = '';
    data.productVisibility = true;

    try {
      const res = await WebinarsDataService.filterUpcomingWebinars('', '');
      data.upcoming = await res.data;
    } catch (err: unknown) {
      console.log('Error fetching upcoming webinars', (err as Error)?.message);
      data.upcoming = {
        count: 0,
        previous: null,
        next: null,
        results: [],
      };
    }

    try {
      const res = await WebinarsDataService.filterPastWebinars('', '');
      data.past = await res.data;
    } catch (err: unknown) {
      console.log('Error fetching past webinars', (err as Error)?.message);
      data.past = {
        count: 0,
        previous: null,
        next: null,
        results: [],
      };
    }

    return {
      props: {
        data: data,
      },
    };
  }
);

export default Webinars;
